import { render } from "./TeacherResponseReport.vue?vue&type=template&id=5a83aab3&scoped=true"
import script from "./TeacherResponseReport.vue?vue&type=script&lang=js"
export * from "./TeacherResponseReport.vue?vue&type=script&lang=js"

import "./TeacherResponseReport.vue?vue&type=style&index=0&id=5a83aab3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a83aab3"]])

export default __exports__